export default "__VITE_PUBLIC_ASSET__d3958c1d__"